import { isRpmModule } from 'infrastructure/functions';
import { showResult } from 'infrastructure/hooks/utils';
import dataService from 'services/dataService';
import { API_UNTRACKED_CALL_CALL_RECORD } from 'services/dataService/resources/callManagement';

import type { GetCallRecordLinkProps } from './types';

const getUrl = ({ callId, patientGuid, module }: GetCallRecordLinkProps) => {
  if (module === 'untracked') {
    return API_UNTRACKED_CALL_CALL_RECORD(callId);
  }
  if (isRpmModule(module)) {
    return `core/patients/${patientGuid}/call-record/${callId}`;
  }
  return `core/ccm/patients/${patientGuid}/call-records/${callId}`;
};

export const getCallRecordLinkFn = async (
  dataProps: GetCallRecordLinkProps,
): Promise<string | void> => {
  const url = getUrl(dataProps);

  const { error, data } = await dataService.getList<{ url: string }>(url);

  if (error) {
    showResult(error);
  }

  if (data && data.url) {
    return data.url;
  }
};
